import { useEffect, useState } from "react";
import { ArrowUpRight, Phone } from "lucide-react";
import { BOOKING_URL } from "./shared";

export default function MobileCtaBar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      // show after a bit of scroll so it does not compete with the hero CTA
      setVisible(window.scrollY > 480);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="mobile-cta-bar"
      aria-hidden={!visible}
      className={`md:hidden fixed left-0 right-0 z-40 px-4 pointer-events-none transition-all duration-300 ${
        visible
          ? "opacity-100 translate-y-0 pointer-events-auto"
          : "opacity-0 translate-y-6"
      }`}
      style={{ bottom: "calc(env(safe-area-inset-bottom, 0px) + 12px)" }}
    >
      <div className="bg-[#0C1732]/85 backdrop-blur-xl border border-white/10 rounded-full shadow-[0_20px_50px_-12px_rgba(0,0,0,0.6)] px-3 py-2 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 pl-2 min-w-0">
          <div className="relative w-8 h-8 rounded-full bg-[#FF5C00]/15 flex items-center justify-center shrink-0">
            <Phone className="w-4 h-4 text-[#FF5C00]" />
            <span className="absolute -top-0.5 -right-0.5 w-2 h-2 rounded-full bg-emerald-400" />
          </div>
          <div className="min-w-0">
            <div className="text-[11px] text-white/60 leading-tight">Ready to talk?</div>
            <div className="text-[12px] text-white font-semibold leading-tight truncate">
              Grab a fit call slot
            </div>
          </div>
        </div>
        <a
          href={BOOKING_URL}
          target="_blank"
          rel="noreferrer"
          data-testid="mobile-cta-bar-book-btn"
          className="arco-btn-primary inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-[13px] font-semibold shrink-0"
        >
          Book <ArrowUpRight className="w-3.5 h-3.5" />
        </a>
      </div>
    </div>
  );
}
